module.exports = __webpack_public_path__ + "static/media/image_placeholder.ebe9884b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image_placeholder.jpg
// module id = 1238
// module chunks = 0